import { useEffect } from 'react';
import { Button } from '@easyflow/ui-frontend/components/ui/button';
import { usePersonalAssistantAccess } from '@/contexts/PersonalAssistantAccessContext';

export default function RoutinesEntry() {
  const { assistant, loading, error, refresh, openRoutines } = usePersonalAssistantAccess();
  useEffect(() => { openRoutines(); }, [openRoutines]);
  return (
    <section className="p-6 space-y-3">
      <h1 className="text-xl font-semibold">Routine nell’assistente personale</h1>
      {loading ? (
        <p role="status">Caricamento dell’assistente personale…</p>
      ) : error ? (
        <div role="alert" className="space-y-3">
          <p>{error}</p>
          <Button onClick={() => { void refresh(); }}>Riprova</Button>
        </div>
      ) : assistant?.is_active ? (
        <>
          <p>Le tue routine sono nel pannello interno dell’assistente, accanto alla conversazione.</p>
          <Button onClick={openRoutines}>Apri Routine nell’assistente</Button>
        </>
      ) : (
        <p role="status">Assistente personale non disponibile. Per gestire le routine è necessario un assistente attivo assegnato al tuo utente.</p>
      )}
    </section>
  );
}